import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/today");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-shell grain flex flex-col p-6">
      <header className="pt-10">
        <Link to="/welcome" className="text-xs tracking-[0.3em] uppercase text-muted-foreground" data-testid="back-home">← Back</Link>
      </header>
      <div className="flex-1 flex flex-col justify-center animate-fade-up">
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight">Sign in</h1>
        <p className="mt-3 text-muted-foreground">Your next person is waiting.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs tracking-wide uppercase text-muted-foreground">Email</Label>
            <Input
              id="email" type="email" autoComplete="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 rounded-2xl bg-card border-border"
              data-testid="login-email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs tracking-wide uppercase text-muted-foreground">Password</Label>
            <Input
              id="password" type="password" autoComplete="current-password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12 rounded-2xl bg-card border-border"
              data-testid="login-password"
            />
          </div>
          {err && <p className="text-sm text-destructive" data-testid="login-error">{err}</p>}
          <Button
            type="submit" disabled={loading}
            className="w-full h-14 rounded-full text-base bg-primary hover:bg-primary/90 transition-transform hover:-translate-y-0.5"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="mt-8 text-sm text-center text-muted-foreground">
          New here? <Link to="/register" className="text-primary underline underline-offset-4" data-testid="go-register">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
